import axiosInstance from './api';

export const getAllProducts = () => axiosInstance.get('/products');

export const getProductById = (id, promo) =>
  axiosInstance.get(`/products/${id}`, {
    params: promo ? { promo } : {},
  });

export const createProduct = (productData) => {
  const formData = new FormData();
  Object.entries(productData).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  return axiosInstance.post('/products', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateProduct = (id, productData) => {
  const formData = new FormData();
  Object.entries(productData).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  return axiosInstance.put(`/products/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteProduct = (id) => axiosInstance.delete(`/products/${id}`);


export const removeProductPromo = (id) => {
  return axiosInstance.put(`/products/${id}/remove-promo`);
};
